span<template>
  <div class="container">
    <div v-wechat-title="($route.meta.title = name)"></div>
    <div
      class="ban-box"
      :style="{
        backgroundImage: `url(${mobileBanner})`,
        height: `calc(100vw * 0.75 + ${
          tabLine * 30 + 5 * (tabLine - 1) + 35
        }px)`,
      }"
    >
      <div class="ban_ul">
        <div v-for="(item, index) in tablist" :key="index">
          <div v-if="item.Type != 4" @click="toOtherList('tab', index)">
            {{ item.RecName }}
          </div>
        </div>
        <div
          class="special"
          v-if="specialDesc != null && specialDesc != ''"
          @click="toActIntro"
        >
          活动介绍
        </div>
      </div>
    </div>
    <!-- 通知 -->
    <div class="noticeBox" v-if="liveNotice">
      <span class="iconfont icon-laba"></span>
      <div>
        <van-notice-bar
          scrollable
          :text="liveNotice"
          color="#B17733"
          :speed="50"
        ></van-notice-bar>
      </div>
    </div>
    <!-- 广告位 -->
    <div class="banner">
      <van-swipe
        :show-indicators="false"
        :autoplay="3000"
        :interval="3000"
        :duration="500"
        :circular="true"
        touchable
      >
        <van-swipe-item
          class="newsItem"
          v-for="(item, index) in newsList"
          :key="index"
        >
          <van-image fit="cover" :src="item.Img" />
        </van-swipe-item>
      </van-swipe>
    </div>

    <!-- 模块展示 -->
    <div class="listBox">
      <div v-for="(item, index) in commonList" :key="index" class="moduleBox">
        <div
          class="headline"
          :style="{ marginBottom: `${item.type == 0 ? '0px' : '40px'}` }"
        >
          {{ item.name }}
        </div>

        <div class="live-box" v-if="item.type === 0">
          <div class="hot-box" @click="toLbRanking(item.id, item.name)">
            <img
              src="../../../static/images/index/label.png"
              class="fireIcon"
            />
            <span>最受关注{{ item.name }}</span>
            <span
              class="iconfont icon-right"
              style="font-size: 10px; color: #999"
            ></span>
          </div>
          <div
            v-for="(sitem, sindex) in item.list"
            :key="sindex"
            class="li_item"
          >
            <mini-program
              :path="
                '/subpackagelive/pages/liveDetail/liveDetail?id=' + sitem.LiveId
              "
            >
              <div class="li_top">
                <div class="lit_state">
                  <div
                    class="lits_text"
                    :class="
                      sitem.Status == 1
                        ? 'orange'
                        : sitem.Status == 0
                        ? 'red'
                        : 'purple'
                    "
                  >
                    <span>{{
                      sitem.Status == 0 ? "直播中" : sitem.StatusDesc
                    }}</span>
                  </div>
                  <div v-if="sitem.Status == 1" class="lits_time">
                    {{ sitem.StartTimeDesc }}
                  </div>
                </div>
                <van-image fit="cover" :src="sitem.Cover" class="coverImg" />
                <img
                  src="../../../static/images/index/play.png"
                  class="playIcon"
                />
                <img
                  v-if="sitem.HasPrize == 1"
                  src="../../../static/images/index/ld_icon.png"
                  class="hasPrize"
                />
              </div>
              <div class="li_btm">
                <div class="overFlowOne">{{ sitem.Title }}</div>
                <div class="company">
                  <van-image
                    fit="cover"
                    :src="sitem.HeadlineLogo"
                    round
                    error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
                  />
                  <div class="overFlowOne">{{ sitem.Headline }}</div>
                </div>
              </div>
            </mini-program>
          </div>
          <div
            class="more"
            @click="toOtherList('more', index)"
            v-if="item.list.length >= 8"
          >
            <span>查看更多</span>
            <span
              class="iconfont icon-right"
              style="font-size: 10px; color: #999"
            ></span>
          </div>
        </div>

        <div
          v-if="item.type === 1"
          class="live-box"
          :class="item.recType == 1 || item.recType == 3 ? 'live-box3' : ''"
        >
          <div
            class="li_item"
            v-for="(sitem, sindex) in item.list"
            :key="sindex"
            @click.stop="toDetailHandle(sitem.ContentId, item.recType)"
          >
            <div class="li_top">
              <van-image :src="sitem.Photo" class="coverImg" />
            </div>
            <div class="li_btm">
              <div class="overFlowOne">
                {{ item.recType == 1 ? sitem.Headline : sitem.Title }}
              </div>
              <div class="company" v-if="item.recType == 2">
                <van-image :src="sitem.HeadlineLogo" fit="contain" round />
                <div class="overFlowOne">{{ sitem.Headline }}</div>
              </div>
            </div>
          </div>
          <div
            class="more"
            @click="toOtherList('more', index)"
            v-if="
              (item.recType == 2 && item.list.length >= 4) ||
              ((item.recType == 1 || item.recType == 3) &&
                item.list.length >= 6)
            "
          >
            <span>查看更多</span>
            <span
              class="iconfont icon-right"
              style="font-size: 10px; color: #999"
            ></span>
          </div>
        </div>

        <div class="hotBox" v-if="item.type === 3">
          <div class="tabBox">
            <div
              v-for="(bitem, bindex) in brandClassify"
              :key="bindex"
              class="tabItem"
              :class="bindex == bIndex ? 'active' : ''"
              @click.stop="tabHandle(bindex)"
            >
              {{ bitem.Name }}
            </div>
          </div>
          <div class="scrollBox" id="oneBox">
            <div
              class="scrollItem"
              v-for="(bitem, bindex) in brandList[0]"
              :key="bindex"
              @click="toStoreIndex(bitem.MemberID)"
            >
              <van-image
                fit="contain"
                :src="bitem.Photo"
                error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
              ></van-image>
              <div class="scrollName overFlowTwo">
                {{ bitem.CompanyNameChi }}
              </div>
            </div>
            <div style="margin-top: 6px">
              <div
                class="scrollItem"
                v-for="(bitem, bindex) in brandList[1]"
                :key="bindex"
                @click="toStoreIndex(bitem.MemberID)"
              >
                <van-image
                  fit="contain"
                  :src="bitem.Photo"
                  error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
                ></van-image>
                <div class="scrollName overFlowTwo">
                  {{ bitem.CompanyNameChi }}
                </div>
              </div>
            </div>
          </div>
          <div class="more" @click="toOtherList('more', index)">
            <span>查看更多</span>
          </div>
        </div>

        <div class="partners" v-if="item.type === 4">
          <div
            v-for="(sitem, sindex) in item.list"
            :key="sindex"
            @click.stop="toNav(sitem.Path)"
          >
            <van-image fit="cover" :src="sitem.Img" class="coverImg" />
          </div>
        </div>
      </div>
    </div>
    <!-- 抽奖按钮 -->
    <mini-program
      class="prizeBox"
      path="subpackagelive/pages/luckDraw/luckDraw"
    >
      <img src="../../../static/images/index/fw_icon.png" />
    </mini-program>
  </div>
</template>
<script>
import { getShareData } from "@/utils/share";
import miniProgram from "@/components/miniProgram";
import { Image, NoticeBar, Swipe, SwipeItem, Tab, Tabs } from "vant";
import {
  swipeList,
  specialDetail,
  liveRecommends,
  mobileLiveList,
  liveExhibitionCompanyList,
  liveRecommendsById,
} from "@/api/online";
export default {
  name: "specificActDetail",
  components: {
    "van-image": Image,
    "van-notice-bar": NoticeBar,
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
    "van-tabs": Tabs,
    "van-tab": Tab,
    miniProgram,
  },
  data() {
    return {
      mobileBanner: "", //海报
      tablist: [], //tab标签
      tabLine: 0, //标签行数

      commonList: [],
      sid: 0, //专题id
      name: "", //专题名字
      specialDesc: "", //活动介绍
      liveNotice: "",
      loading: false, //热门品牌展示加载判断
      newsList: [], //广告位
      bIndex: 0,
      brandClassify: [
        {
          Name: "全部",
          HallNos: [],
        },
        {
          Name: "景观照明",
          HallNos: ["11", "21"],
        },
        {
          Name: "智慧城市",
          HallNos: ["31", "51"],
        },
        {
          Name: "文旅照明",
          HallNos: ["41"],
        },
        {
          Name: "光源/灯具",
          HallNos: ["12"],
        },
        {
          Name: "材料/设备",
          HallNos: ["22", "32", "42"],
        },
        {
          Name: "商用照明",
          HallNos: ["102", "112"],
        },
        {
          Name: "民用照明",
          HallNos: ["122", "132"],
        },
        {
          Name: "光·智能",
          HallNos: ["92"],
        },
      ],
      brandList: [[], []],
      pageIndex: 1,
      total: 0,
    };
  },
  methods: {
    tabHandle(idx) {
      this.bIndex = idx;
      this.scrollLeft = 0;
      this.pageIndex = 1;
      this.getLiveExhibitionCompanyList();
    },

    getLiveExhibitionCompanyList() {
      var that = this;
      var data = {
        HallNos: that.brandClassify[that.bIndex].HallNos,
        Page: {
          PageSize: 20,
          PageIndex: that.pageIndex,
        },
      };
      liveExhibitionCompanyList(data).then((res) => {
        var list = [[], []];
        that.total = res.Data.Total;
        res.Data.List.forEach(function (item, index) {
          if (index % 2 == 1) {
            list[1].push(item);
          } else {
            list[0].push(item);
          }
        });
        if (that.pageIndex == 1) {
          that.brandList = list;
        } else {
          var first = that.brandList[0].concat(list[0]);
          var second = that.brandList[1].concat(list[1]);
          that.brandList = [first, second];
        }
        this.loading = false;
      });
    },

    //判断滚动条位置
    toScrolltolower() {
      const scrollDiv = document.getElementById("oneBox");
      var len = this.brandList[0].length + this.brandList[1].length;
      var scrollLeft = scrollDiv.scrollLeft;
      var width = this.pageIndex * 10 * 100 + this.pageIndex * 10;
      if (len < this.total) {
        if (scrollLeft > width - document.body.clientWidth && !this.loading) {
          this.pageIndex += 1;
          this.loading = true;
          this.getLiveExhibitionCompanyList();
        }
      }
    },

    //跳转展厅
    toStoreIndex(mid) {
      this.$router.push({ path: "/storeShow", query: { mid: mid } });
    },

    //跳转展厅
    toStoreShow(path) {
      if (path.indexOf("?") != -1) {
        var mid = path.split("?")[1].split("=")[1];
        this.$router.push({ path: "/storeShow", query: { mid: mid } });
      }
    },

    //跳转详情(type=1)
    toDetailHandle(id, rtype) {
      if (rtype == 1) {
        this.$router.push({ path: "/storeShow", query: { mid: mid } });
      } else if (rtype == 2) {
        this.$router.push({ path: "/videoDetail", query: { id: id } });
      } else if (rtype == 3) {
        this.$router.push({ path: "/productDetail", query: { id: id } });
      }
    },

    //跳转展厅或者产品
    toNav(path) {
      if (path.indexOf("?") != -1) {
        if (path.split("?")[0] == "/pages/productDetail/productDetail") {
          var goodId = path.split("goodId")[1].split("=")[1];
          this.$router.push({ path: "/productDetail", query: { id: goodId } });
        } else if (path.split("?")[0] == "/pages/storeIndex/storeIndex") {
          var mid = path.split("?")[1].split("=")[1];
          this.$router.push({ path: "/storeShow", query: { mid: mid } });
        } else {
        }
      }
    },

    //跳转模块列表
    toOtherList(btn, idx) {
      var tag, recContent, lid, type;
      if (btn == "more") {
        //更多点击
        tag = this.commonList[idx];
        recContent = tag.recContent;
        lid = tag.id;
        type = tag.type;
      } else {
        //导航栏点击
        tag = this.tablist[idx];
        recContent = tag.MobileRecContent;
        lid = tag.LiveRecId;
        type = tag.Type;
      }
      if (type == 0 || type == 1) {
        this.$router.push({
          path: "/lbList",
          query: {
            lid: lid,
            sid: this.$route.query.sid,
          },
        });
      } else if (type == 3) {
        this.$router.push("/expoLatestBooth");
      } else {
        window.location.href = recContent;
      }
    },

    toActIntro() {
      this.$router.replace({
        path: "/actIntro",
        query: { sid: this.$route.query.sid },
      });
    },

    //去排行榜
    toLbRanking(id, name) {
      this.$router.replace({
        path: "/lbRanking",
        query: { recommend: id, sid: this.$route.query.sid, name: name },
      });
    },

    //获取专题详情
    getSpecialDetail() {
      var that = this;
      var data = {
        SpecialId: that.$route.query.sid,
      };
      specialDetail(data).then((res) => {
        that.mobileBanner = res.Data.MobileBanner;
        that.specialDesc = res.Data.SpecialDesc;
        that.name = res.Data.Name;
        that.liveNotice = res.Data.LiveNotice;
      });
      that.getLiveExhibitionCompanyList();
      that.getBanner();
      that.getRecommendMsg();
    },

    //获取推荐信息
    getRecommendMsg() {
      var that = this;
      var data = {
        SpecialId: that.$route.query.sid,
      };
      liveRecommends(data).then((res) => {
        that.tablist = res.Data.List;
        that.tabLine = Math.ceil(res.Data.List.length / 3);
        res.Data.List.forEach((element) => {
          if (element.RecName == "首页") {
            var recContent = element.MobileRecContent;
            if (
              recContent ==
              "/subpackagelive/pages/onlineExhibitionTopics/onlineExhibitionTopics"
            ) {
              this.$router.replace("/onlineExhibitionTopics");
            }
          }
          that.getData(element);
        });
      });
    },

    //根据type判断
    getData(data) {
      if (data.Type == 0) {
        this.getMobileLiveList(data, this.commonList.push({}) - 1);
      } else if (data.Type == 1) {
        this.getRecommendList(data, this.commonList.push({}) - 1);
      } else if (data.Type == 3) {
        //参展商
        this.pushData(data, [], this.commonList.push({}) - 1); //只用brandList数组
        this.getLiveExhibitionCompanyList();
      } else if (data.Type == 4) {
        //合作机构
        this.getPartnerList(data, this.commonList.push({}) - 1);
      } else {
      }
    },

    //获取推荐位
    getRecommendList(model, index) {
      var that = this;
      var data = {
        LiveRecId: model.LiveRecId,
        Keyword: "",
        Page: {
          PageSize: 6, //视频要4条数据，企业产品要6条，统一请求6条
          PageIndex: 1,
        },
      };
      liveRecommendsById(data).then((res) => {
        model.RecType = res.Data.RecType;
        if (model.RecType == 2) {
          res.Data.RecContentList = res.Data.RecContentList.slice(0, 4);
        }
        that.pushData(model, res.Data.RecContentList, index);
      });
    },

    //获取直播列表
    getMobileLiveList(model, index) {
      var that = this;
      var data = {
        CategoryId: 0,
        MemberId: 0,
        Keyword: "",
        Page: {
          PageSize: 8,
          PageIndex: 1,
        },
        Recommend: Number(model.LiveRecId) ? Number(model.LiveRecId) : null,
        SpecialId: Number(that.$route.query.sid)
          ? Number(that.$route.query.sid)
          : 0,
        HasQrcode: 1,
      };
      mobileLiveList(data).then((res) => {
        var newlist = res.Data.List;
        newlist.forEach((item, index) => {
          item.StartTimeDesc = item.StartTimeDesc.substr(5).replace(/-/g, "/");
        });
        that.pushData(model, newlist, index);
      });
    },

    pushData(model, list, index) {
      var obj = {
        id: model.LiveRecId,
        type: model.Type,
        recType: model.RecType ? model.RecType : 0,
        name: model.RecName,
        recContent: model.MobileRecContent,
        list: list,
      };
      this.$set(this.commonList, index, obj);
    },

    getBanner() {
      var data = {
        Type: 303,
      };
      swipeList(data).then((res) => {
        this.newsList = res.Data.List;
      });
    },

    getPartnerList(model, index) {
      var that = this;
      var data = {
        Type: model.MobileRecContent,
        Keyword: "",
      };
      swipeList(data).then((res) => {
        that.pushData(model, res.Data.List, index);
      });
    },
  },

  created() {
    this.sid = this.$route.query.sid;
  },

  mounted() {
    if (this.Common._isMobile()) {
      this.getSpecialDetail();
      const scrollDiv = document.getElementById("oneBox");
      if (scrollDiv) {
        scrollDiv.addEventListener("touchmove", this.toScrolltolower, false);
      }
      getShareData(window.location.href, "2022阿拉丁网上照明展", this.name);
    } else {
      window.location.href = "https://www.alighting.com/views/lives.html";
    }
  },
};
</script>
<style lang="less" scoped>
.container {
  .ban-box {
    background-repeat: no-repeat;
    background-position: center top;
    background-size: 100% auto;
    position: relative;
    .ban_ul {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      position: absolute;
      bottom: 0;
      width: 100%;
      padding: 20px 0 10px 0;
      background-color: rgba(0, 0, 0, 0.2);
      div {
        div {
          width: 105px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background: #333333;
          border-radius: 6px;
          color: #fff;
          font-size: 12px;
          margin: 0 0 5px 18px;
          word-break: break-all;
        }
      }
    }
  }

  .noticeBox {
    height: 40px;
    display: flex;
    align-items: center;
    background-color: #e7cb1c;
    .iconfont {
      font-size: 15px;
      color: #ca0000;
      padding-left: 8px;
    }
    /deep/.van-notice-bar__content {
      min-width: 100.1% !important;
    }
    div {
      width: 300px;
      /deep/.van-notice-bar {
        color: #000 !important;
        font-size: 12px;
        height: 40px;
        background-color: #e7cb1c;
        padding: 0px 6px;
      }
    }
  }

  .listBox {
    .module-box {
      &:last-child {
        border: 0px;
      }
    }
  }
  .prizeBox {
    position: fixed;
    right: 10px;
    bottom: 20px;
    z-index: 1;
    img {
      width: 70px;
      height: 70px;
    }
  }
  .codePrizeBox {
    position: relative;
    top: 100px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    font-size: 13px;
    z-index: 9999;
    .prizeImg {
      width: 280px;
      height: 315px;
    }
    .codeImgBox {
      position: absolute;
      top: 105px;
      left: 50%;
      transform: translateX(-50%);
      img {
        width: 140px;
        height: 140px;
      }
    }
  }
  .prizeCloseImg {
    width: 40px;
    height: 40px;
    position: absolute;
    bottom: 180px;
    left: 50%;
    transform: translateX(-50%);
  }

  .sBox {
    width: 100%;
    .van-image {
      width: 100%;
      height: 100%;
      display: block;
    }
    .sUl {
      width: 100%;
      background-color: #000;
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      padding: 20px 0px 14px 0px;
      div {
        div {
          width: 100px;
          text-align: center;
          height: 30px;
          line-height: 30px;
          background: #333;
          border-radius: 6px;
          color: #ffffff;
          font-size: 13px;
          margin-left: 16px;
          margin-bottom: 6px;
          padding: 0px 2px;
        }
      }
    }
  }

  .banner {
    margin: 29px 20px 0px 20px;
    .newsItem {
      width: 335px;
      height: 115px;
      border-radius: 5px;
    }
    /deep/.van-swipe__indicator {
      width: 3px;
      height: 3px;
      border-radius: 3px;
    }
    /deep/.van-swipe__indicator--active {
      width: 10px;
      height: 3px;
      background: #ffffff;
      border-radius: 3px;
    }
    .van-image {
      width: 335px;
      height: 115px;
      /deep/.van-image__img {
        border-radius: 5px;
      }
    }
  }

  .hotBox {
    margin-top: 28px;
    .headline {
      color: #000000;
      font-size: 20px;
      text-align: center;
      font-weight: bold;
    }
    .tabBox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      white-space: nowrap;
      overflow-x: scroll;
      overflow-y: hidden;
      margin: 0px 12px;
      &::-webkit-scrollbar {
        display: none;
      }
      .tabItem {
        font-size: 12px;
        color: #666;
        margin-right: 30px;
      }
      .active {
        background-color: #000;
        font-weight: bold;
        color: #ffe22a;
        border-radius: 15px;
        padding: 8px 15px;
      }
    }
    .scrollBox {
      margin-top: 22px;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      margin-right: 10px;
      .scrollItem {
        vertical-align: top;
        display: inline-block;
        width: 100px;
        height: 140px;
        background-color: #ca0000;
        margin-left: 11px;
        padding: 2px;
        .van-image {
          width: 100px;
          height: 100px;
          display: block;
          background-color: #fff;
        }
        .scrollName {
          background-color: #ca0000;
          font-size: 11px;
          color: #fff;
          line-height: 15px;
          padding: 4px 3px 2px 3px;
          white-space: normal;
        }
      }
    }
    .more {
      width: 80px;
      height: 30px;
      line-height: 30px;
      border: 1px solid #cccccc;
      border-radius: 15px;
      font-size: 12px;
      color: #666;
      text-align: center;
      margin: 25px auto;
    }
  }
  .coBox {
    margin: 38px 0px;
    .headline {
      color: #000000;
      font-size: 20px;
      text-align: center;
      font-weight: bold;
    }
    .imgBox {
      display: flex;
      flex-wrap: wrap;
      margin: 0px 16px;
      .van-image {
        display: block;
        width: 77px;
        height: 45px;
        border: 1px solid #ddd;
        margin-right: 7px;
        margin-bottom: 8px;
        &:nth-child(4n) {
          margin-right: 0px;
        }
      }
    }
  }
}
.listBox {
  div:last-child {
    border-bottom: 0px;
  }
}
/* 合作机构 */
.partners {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding-left: 16px;
}

.partners > div {
  border: 1px solid #efefef;
  width: 80px;
  height: 45px;
  margin-bottom: 9px;
}

.partners > div:not(:nth-child(4n)) {
  margin-right: 7px;
}

.partners > div > .van-image {
  width: 100%;
  height: 100%;
  display: block;
}

.special {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #333333;
  border-radius: 6px;
  color: #fff;
  font-size: 12px;
  margin: 0 0 5px 18px;
}
</style>

